import * as THREE from "three";
import { useEffect, useRef } from "react";

export function Arrowhead({
  params,
  position,
  direction,
  visible,
  arrowHeight = 4,
  flip = false,
  scaleFactor,
}) {
  const coneRef = useRef();
  arrowHeight = arrowHeight / scaleFactor; // Scale depending on m, cm, mm

  useEffect(() => {
    if (coneRef.current) {

      // Calculate the length of the line
      const lineLength = new THREE.Vector3().subVectors(position, direction).length();
      console.log("line length:", lineLength);

      // Determine the direction vector - whether the arrows are flipped or not
      let directionVector;
      // arrowHeight * 3 because in the gap I want 2 arrows to fit along with a gap between them of an arrow height
      if (arrowHeight * 3 > lineLength) {
        directionVector = new THREE.Vector3().subVectors(direction, position).normalize(); // Point inwards
        coneRef.current.quaternion.setFromUnitVectors(
          new THREE.Vector3(0, 1, 0),
          directionVector
        );
      } else {
        directionVector = new THREE.Vector3().subVectors(position, direction).normalize(); // Point outwards
        coneRef.current.quaternion.setFromUnitVectors(
          new THREE.Vector3(0, 1, 0),
          directionVector
        );
      }

      // Offset the cone's position
      const offsetPosition = new THREE.Vector3()
        .copy(position)
        .sub(directionVector.multiplyScalar(arrowHeight / 2));

      coneRef.current.position.copy(offsetPosition);
    }
  }, [position, direction, flip, arrowHeight]);
  console.log("line colour:", params.line_colour);

  return (
    <mesh ref={coneRef} position={position} visible={visible}>
      <coneGeometry args={[1 / scaleFactor, arrowHeight, 10]} />
      <meshBasicMaterial
        color={params.line_colour}
        transparent
        opacity={params.cone_opacity}
      />
    </mesh>
  );
}